import { createSlice } from '@reduxjs/toolkit';

const skillSlice = createSlice({
  name: 'skill',
  initialState: {
    skills: [],
    memberSkills: [],
    certifications: [],
    expiringCertifications: [],
    selectedSkill: null,
    selectedMemberSkill: null,
    selectedCertification: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    setSkills(state, action) {
      state.skills = action.payload;
    },
    setMemberSkills(state, action) {
      state.memberSkills = action.payload;
    },
    setCertifications(state, action) {
      state.certifications = action.payload;
    },
    setExpiringCertifications(state, action) {
      state.expiringCertifications = action.payload;
    },
    setSelectedSkill(state, action) {
      state.selectedSkill = action.payload;
    },
    setSelectedMemberSkill(state, action) {
      state.selectedMemberSkill = action.payload;
    },
    setSelectedCertification(state, action) {
      state.selectedCertification = action.payload;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    addSkill(state, action) {
      state.skills.push(action.payload);
    },
    updateSkill(state, action) {
      const index = state.skills.findIndex(s => s.id === action.payload.id);
      if (index !== -1) {
        state.skills[index] = action.payload;
      }
    },
    removeSkill(state, action) {
      state.skills = state.skills.filter(s => s.id !== action.payload);
    },
    addMemberSkill(state, action) {
      state.memberSkills.push(action.payload);
    },
    updateMemberSkillItem(state, action) {
      const index = state.memberSkills.findIndex(ms => ms.id === action.payload.id);
      if (index !== -1) {
        state.memberSkills[index] = action.payload;
      }
    },
    removeMemberSkill(state, action) {
      state.memberSkills = state.memberSkills.filter(ms => ms.id !== action.payload);
    },
    addCertification(state, action) {
      state.certifications.push(action.payload);
    },
    updateCertificationItem(state, action) {
      const index = state.certifications.findIndex(c => c.id === action.payload.id);
      if (index !== -1) {
        state.certifications[index] = action.payload;
      }
    },
    removeCertification(state, action) {
      state.certifications = state.certifications.filter(c => c.id !== action.payload);
    },
    clearSkillState(state) {
      state.skills = [];
      state.memberSkills = [];
      state.certifications = [];
      state.expiringCertifications = [];
      state.selectedSkill = null;
      state.selectedMemberSkill = null;
      state.selectedCertification = null;
      state.error = null;
    },
  },
});

export const skillActions = skillSlice.actions;

export default skillSlice;

